module.exports = __webpack_public_path__ + "static/media/linkedin_icon.d2345186.png";